

<div class="card">
    <div class="card-body">
      <!-- <span translate="shifts.break" *ngIf="data.isOnBreak"
        class="badge bg-warning text-white fs-14 p-2 fw-600 position-absolute id-card">
      </span> -->
      <div class="d-flex">
        <div class="flex-shrink-0">
          <img [src]="data.siteSupervisorShift.companySecurityGuard.securityGuard.photo?.fullLink" onerror="this.src = 'assets/images/icons/earth.png'" width="60" height="60"
            class="obj-cover rounded-3" />
        </div>
        <div class="flex-grow-1 mis-3">
          <h5 class="mt-0 fw-500">
            {{
            data.siteSupervisorShift.companySecurityGuard.securityGuard.firstName
            +" "+data.siteSupervisorShift.companySecurityGuard.securityGuard.middleName
            +" "+data.siteSupervisorShift.companySecurityGuard.securityGuard.lastName}}
          </h5>
          <p class="fs-14 m-0 text-info"><span translate="reports.entry_time"></span>
            {{start?.split(' ')[1]}}
          </p>
          <p *ngIf="end" class="fs-14 m-0 text-info"><span translate="reports.leave_time"></span>
            {{endTime.split(' ')[1]}}
          </p>
          <!-- <p *ngIf="break" class="fs-14 m-0 text-info"><span translate="reports.break_time"></span>
            {{break}}
          </p>
          <p *ngIf="totalwork" class="fs-14 m-0 text-info"><span translate="reports.actual_work_time"></span>
            {{totalwork}}
          </p>
        </div> -->
      </div>
    </div>
  </div>
  